module.exports = value => (value ? value.substring(0, 80) + '...' : '');
